import json from "../json/registrationsGetRatePlanTiers.json";

export default async () => JSON.parse(JSON.stringify([await json]));
